import { Injectable } from '@angular/core'
import { doc, Firestore, getDoc } from '@angular/fire/firestore'
import { Functions, httpsCallable } from '@angular/fire/functions'
import { BuildingAllocation, BuildingAllocationRow, LandlordInsights, MarketInsights } from '@parkupp/core'

@Injectable({ providedIn: 'root' })
export class ParkingInsightsService {
    constructor(private firestore: Firestore, private functions: Functions) {}
    async market(): Promise<MarketInsights | null> {
        const snapshot = await getDoc(doc(this.firestore, 'marketInsights', 'current'))
        return snapshot.exists() ? (snapshot.data() as MarketInsights) : null
    }
    async landlord(merchantKey: string): Promise<LandlordInsights | null> {
        return (await httpsCallable<{ merchantKey: string }, LandlordInsights | null>(this.functions, 'getLandlordInsights')({ merchantKey })).data
    }
    async allocations(): Promise<BuildingAllocationRow[]> {
        return (await httpsCallable<{}, BuildingAllocationRow[]>(this.functions, 'getBuildingAllocations')({})).data
    }
    async saveAllocation(value: BuildingAllocation): Promise<void> {
        const { parkingKey, city, suburb, category, confirmed, excluded } = value
        await httpsCallable(this.functions, 'saveBuildingAllocation')({ parkingKey, city, suburb, category, confirmed, excluded })
    }
    async refresh(): Promise<void> {
        await httpsCallable(this.functions, 'refreshParkingInsights', { timeout: 540000 })({})
    }
}
